import React from "react"

import InfoModal from "../components/InfoModal"

import log from "./log"

// eslint-disable-next-line
export const notifyLoginBlockIfNeeded = (frontData) => {
	const wasPreviouslyLoginBlockNotified = log.wasPreviouslyLoginBlockNotified()

	if (wasPreviouslyLoginBlockNotified) {
		return
	}

	if (frontData.blocked_private_selection_login === true) {
		log.disableLoginBlockNotification()

		InfoModal.warning({
			title: "Galeria privada",
			message: (
				<p>
					A galeria que você está acessando é privada.
					<br />
					<br />
					Somente clientes escolhidos pelo
					<br />
					fotógrafo podem fazer login.
				</p>
			)
		})
	}
}